import React from 'react'
import { Link } from 'react-router-dom'
import separator from './../../public/breadcrumb-separation.svg'

interface BreadcrumbProps {
  levels: { label: string; path?: string }[]
}

const Breadcrumb = ({ levels }: BreadcrumbProps) => {
  return (
    <div className="breadcrumb">
      {levels.map((level, index, arr) => {
        const { label, path } = level
        const isLast = index === arr.length - 1

        const content =
          path && path.length > 0 ? (
            <Link to={path} className={isLast ? 'last' : ''}>
              {label}
            </Link>
          ) : (
            <span className={isLast ? 'last' : ''}>{label}</span>
          )

        return (
          <React.Fragment key={index}>
            {content}
            {!isLast && <img src={separator} alt="breadcrumb-separator" />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Breadcrumb
